import React from 'react';
import DesktopMessage from './DesktopMessage';
import MobileMessage from './MobileMessage';

interface DateTime {
  date: string; // UTC date
  timezone: string;
}

export interface Props {
  darkMode?: boolean;
  asset?: string;
  url?: string;
  title: string;
  text: string;
  avatar: string;
  user: string;
  timestamp: DateTime;
  platform: string;
  imageAlt?: string;
}

export default function SocialMediaMessage(props: Props) {
  return (
    <>
      <DesktopMessage {...props} />
      <MobileMessage {...props} />
    </>
  );
}
